import cx from 'classnames';
import PropTypes from 'prop-types';
import withTheme from 'core/hocs/withTheme';

import styles from './index.styl';

function NotifyIcon({ theme, className }) {
  return (
    <span className={cx(styles.notify, 'notify', className)}>
      <style jsx>{`
        .notify
          background ${theme.colors.error}
          font-family ${theme.fonts.display}
      `}</style>
      !
    </span>
  );
}

NotifyIcon.propTypes = {
  theme: PropTypes.object,
  className: PropTypes.string,
};

export default withTheme(NotifyIcon);
